import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CatalogosComponent } from "./catalogos/catalogos.component";
import { PermisosComponent } from '../seguridad/permisos/permisos.component';
import { ReportesComponent } from '../ingresos/reportes/reportes.component';
import { AuthGuard } from "app/_helpers/auth.guard";
import { BuscaBitacoraGridComponent } from '../componentes/busca-bitacora-grid/busca-bitacora-grid.component';
import { PrescripcionComponent } from "app/componentes/prescripcion/prescripcion.component";
import { EdicionCargoComponent } from 'app/componentes/edicion-cargo/edicion-cargo.component';
import { CatDescuentosComponent } from '../componentes/cat-descuentos/cat-descuentos.component';

const routes: Routes = [
 

  {
    path: "",
    children: [
      {
        path: "busca-bitacora-grid",
        component: BuscaBitacoraGridComponent
        ,
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "permisos",
        component: PermisosComponent
        ,
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "catalogos",
        component: CatalogosComponent
      }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "reportes",
        component: ReportesComponent
      }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "prescripcion",
        component: PrescripcionComponent,
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "edicion-cargo",
        component: EdicionCargoComponent,
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "cat-descuentos",
        component: CatDescuentosComponent,
        canActivate: [AuthGuard],
      },
   ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdministracionRoutingModule {}
